import React,{Component,Fragment,createRef} from 'react';
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import axios from 'axios';
import qs from 'qs';
import {withRouter} from 'react-router-dom'


const QUICK_BULK_SEARCH_CLASSNAME = 'of-quick-bulk-search-connector'

export class QuickSearchDomain extends Component{
  constructor(props){
    super(props);
    this.state = {
      featured_domains : null,
      added_featured_domains: [],
      open_dropdown: false,
      search_type: 'register',
      viewport: undefined,
      fetching: true
    }
    this.removeSelectedTLD = this.removeSelectedTLD.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.searchDomainField = createRef();
  }
  onFormSubmit(e){
    e.preventDefault()
    if(this.searchDomainField && this.searchDomainField.current && this.searchDomainField.current.value){
      const {history} = this.props;
      const {added_featured_domains} = this.state
      let tlds= ''
      if(added_featured_domains && added_featured_domains.length > 0){
        tlds = encodeURIComponent(added_featured_domains);
      }
      history.push(`${history.location.pathname}?a=add&domain=register&query=${this.searchDomainField.current.value}&tlds=${tlds}`)
    }
  }
  computeViewport(width){
    if(width<768){
      return 'xs';
    }else if(width>767 && width<992){
      return 'sm';
    }else if(width>991 && width<1200){
      return 'md';
    }else if(width>1199){
      return 'lg';
    }
  }
  componentDidUpdate(prevProps,prevState){
    const {fetching} = this.state;
    const {computeViewport} = this;
    if(fetching !== prevState.fetching && fetching){
      const window_width = window.innerWidth;
      const viewport = computeViewport(window_width);
      this.setState({
        ...this.state,
        viewport
      });
    }
  }
  componentDidMount(){
    const {ajax_url,pageID} = this.props;
    const {computeViewport} = this;
    const window_width = window.innerWidth;
    const viewport = computeViewport(window_width);
    this.setState({
      ...this.state,
      viewport,
      fetching: true
    });
    window.addEventListener('resize',()=>{
      const window_width = window.innerWidth;
      const viewport = computeViewport(window_width);
      this.setState({
        ...this.state,
        viewport
      });
    });
    axios.post(ajax_url,qs.stringify({
      action : 'getFeaturedDomainsAjax',
      pageID
    })).then((response)=>{
      const {data} = response;
      const {featured_domains} = data;
      this.setState({
        ...this.state,
        featured_domains,
        fetching: false
      })
    },(error)=>{
      console.log(error);
    });
  }
  removeSelectedTLD(tldname){
    const {added_featured_domains} = this.state;
    let added_featured_domains_temp = Object.assign([], added_featured_domains);
    for (var key in added_featured_domains_temp) {
      if (added_featured_domains_temp[key] === tldname) {
        added_featured_domains_temp.splice(key, 1);
      }
    }
    if(added_featured_domains_temp && added_featured_domains_temp.length>0){
      this.setState({
        ...this.state,
        added_featured_domains: added_featured_domains_temp
      })
    }else{
      this.setState({
        ...this.state,
        added_featured_domains: [],
        open_dropdown: false
      })
    }

  }
  render(){
    const {theme_url,ordering_site,domain_pricing,container} = this.props;
    const {featured_domains,added_featured_domains,open_dropdown,search_type,viewport,fetching} = this.state;
    const {removeSelectedTLD,onFormSubmit} = this;
    const renderFeaturedDomain = () =>{
      if(featured_domains && featured_domains.length){
        return featured_domains.map((item,index)=>{
          const {logo,register_price,on_sale,old_price,name,transfer_price} = item;
          const isTLDAddded = () =>{
            let isadded = false;
            if(added_featured_domains && added_featured_domains.length>0) {
              added_featured_domains.forEach( i => {
                if(i===name){
                  isadded = true;
                }
              });
            }
            return isadded;
          }
          const is_tld_added = isTLDAddded();
          return(
            <div key={index} className={`table__column clearfix table__column--${index}${is_tld_added && search_type==='register'?' table__column--added':''}${search_type==='transfer'?' table__column--transfer':''}`} onClick={e=>{
              e.preventDefault();
              if(search_type==='register'){
                let added_featured_domains_temp = Object.assign([], added_featured_domains);
                if(is_tld_added===false){
                  added_featured_domains_temp.push(name);
                }else{
                  for (var key in added_featured_domains_temp) {
                    if (added_featured_domains_temp[key] === name) {
                      added_featured_domains_temp.splice(key, 1);
                    }
                  }
                }
                this.setState({
                  ...this.state,
                  added_featured_domains: added_featured_domains_temp
                });
              }
            }}>
              {logo?<img className={`column__logo`} src={logo} alt={'logo'} />:<></>}
              <div className={`column__right`}>
                {
                  on_sale && search_type==='register'?
                    <div className={`column__price-wrapper${on_sale?' column__price-wrapper--onsale':''}`}>
                      <div className={`column__price column__price--current`}>${register_price}<span className={`price__period`}>/yr</span></div>
                      <div className={`column__price column__price--old`}>${old_price}<span className={`price__period`}>/yr</span></div>
                    </div>
                    :<div className={`column__price-wrapper column__price--current`}>
                      <div className={`column__price${transfer_price==='Free'&search_type==='transfer'?' column__price--free':''}`}>
                        {search_type==='transfer'&& transfer_price==='Free'?'':'$'}
                        {search_type==='register'?register_price:transfer_price}
                        {search_type==='transfer'&& transfer_price==='Free'?'':<span className={`price__period`}>/yr</span>}
                      </div>
                    </div>
                }
                {search_type==='register' && viewport!=='xs'?<div className={`column__action`}>
                  <div className={`action__button${is_tld_added?' action__button--added':''}`}>
                    {is_tld_added ? <Fragment><span className="text text--red">Remove</span><span className="icon icon-remove1"></span></Fragment> : <Fragment><span className="text">Add To Search</span><span className="icon icon-add"></span></Fragment>}
                  </div>
                </div>:''}
              </div>
            </div>
          )
        });
      }
    }
    const renderTLDs = () =>{
      if(added_featured_domains && added_featured_domains.length>0){
        if(added_featured_domains.length>3){
          let no_dropdown_items = added_featured_domains.length-2;
          const renderFirstTwoTLDS = () =>{
            return added_featured_domains.map((item,index)=>{
              if(index<2){
                return (
                  <div key={index} className={`tld clearfix`}>
                    <div className={`tld__name`}>{item}</div>
                    <div onClick={()=>{
                      removeSelectedTLD(item);
                    }} className={`tld__close`}><i className={`icon icon-close`}/></div>
                  </div>
                )
              }
              return (<Fragment key={index} />)

            });
          }
          const renderDropdown = () =>{
            return added_featured_domains.map((item,index)=>{
              if(index>=2){
                return (
                  <div key={index} className={`dropdown__item clearfix`}>
                    <div className={`item__name`}>{item}</div>
                    <div onClick={()=>{
                      removeSelectedTLD(item)
                    }} className={`item__close`}><span className={`icon icon-close`}/></div>
                  </div>
                )
              }
              return (<Fragment key={index} />)
            });
          }
          class DropdownButton extends Component{
            constructor(props){
              super(props);
              this.bindClickAway = this.bindClickAway.bind(this);
              this.currentRef = null;
            }
            bindClickAway(e){
              const{currentRef} = this;
              const{parent} = this.props;
              if(currentRef && currentRef!== e.target && !currentRef.contains(e.target)){

                parent.setState({
                  ...parent.state,
                  open_dropdown: false
                })
              }
            }
            componentDidMount(){
              const {bindClickAway} = this;
              document.addEventListener('click',bindClickAway);
            }
            componentWillUnmount(){
              const {bindClickAway} = this;
              const {parent} = this.props;
              const {added_featured_domains} = parent.state;
              document.removeEventListener('click',bindClickAway);
              if(added_featured_domains.length<4){
                parent.setState({
                  ...parent.state,
                  open_dropdown: false
                });
              }
            }
            render(){
              return(
                <div ref={el=>{
                  this.currentRef = el;
                }}  className={`dropdown__bottom`}>
                  {renderDropdown()}
                </div>
              )
            }
          }
          DropdownButton.propTypes = {
            parent: PropTypes.any,
          }
          return (
            <div className={`tlds__wrapper`}>
              <div className={`tlds__list clearfix`}>{renderFirstTwoTLDS()}</div>
              <div className={`tlds__dropdown clearfix`}>
                <div onClick={()=>{
                  if(open_dropdown){
                    this.setState({
                      ...this.state,
                      open_dropdown: false
                    })
                  }else{
                    this.setState({
                      ...this.state,
                      open_dropdown: true
                    })
                  }
                }} className={`dropdown__top`}>{no_dropdown_items} more</div>
                {open_dropdown?<DropdownButton parent={this} />:''}
              </div>
            </div>
          )
        }else{
          return added_featured_domains.map((item,index)=>{
            return (
              <div key={index} className={`tld clearfix`}>
                <div className={`tld__name`}>{item}</div>
                <div onClick={()=>{
                  removeSelectedTLD(item);
                }} className={`tld__close`}><span className={`icon icon-close`}></span></div>
              </div>
            )
          });
        }

      }
    }
    const renderTLDSInput = () =>{
      if(added_featured_domains && added_featured_domains.length>0){
        return added_featured_domains.map((item,index)=>{
          return (
            <input key={index} type={`hidden`} name ={`tlds[]`} value={item}/>
          );
        })
      }
    }
    const renderPlaceholder = ()=>{
      if(search_type==='register'){
        if(viewport==='xs' || added_featured_domains.length ){
          return 'Start your search here!';
        }else{
          return 'Start your search or enter a keyword here!';
        }

      }else{
        if(viewport==='xs'|| added_featured_domains.length){
          return 'Enter the domain name';
        }else{
          return 'Enter the domain name you want to transfer';
        }

      }
    }
    if(fetching){
      return ReactDOM.createPortal(
        <div className={`QuickSearchDomain QuickSearchDomain--loading clearfix`}>
          <img className={`QuickSearchDomain__spinner-logo z-spinner--css`} src={`${theme_url}/images/zLogo.png`} alt={`loading`} />
        </div>
      ,container)
    }
    return ReactDOM.createPortal(
      <div className={`QuickSearchDomain QuickSearchDomain--success clearfix`}>
        <div className={`QuickSearchDomain__top clearfix${open_dropdown?' QuickSearchDomain__top--open-dropdown':''}`}>
          <div className={`top__main clearfix`}>
            <div className={`top__wide-container wide-container`}>
              <div className={`top__body clearfix`}>
                <div className={`container clearfix QuickSearchDomain__container`}>
                  <form method={`get`} className={`body__form clearfix`} action={`${ordering_site}/cart.php`} onSubmit={onFormSubmit}>
                    <div className={`form__wrapper clearfix`}>
                      <input ref={this.searchDomainField} name={`query`} className={`form__text`} type={`text`} placeholder={renderPlaceholder()} onFocus={(e)=>{
                        e.currentTarget.placeholder="";
                      }} onBlur={(e)=>{
                        e.currentTarget.placeholder= renderPlaceholder();
                      }}/>
                      <input name={`a`} type={`hidden`} value={'add'} />
                      { search_type==='register'? <input name={`domain`} type={`hidden`} value={`register`}/>: <input name={`domain`} type={`hidden`} value={`transfer`}/>}
                      { search_type==='register'? renderTLDSInput(): ''}
                      {viewport!=='xs'?<div className={`form__tlds clearfix`}>{search_type==='register'?renderTLDs():''}</div>:''}
                      {viewport!=='xs'?<button type={`submit`} className={`form__button`}><span className={`icon icon-search`}></span></button>:''}
                    </div>
                    {viewport==='xs'?<button type={`submit`} className={`form__button form__button--mobile`}><span className={`icon icon-search`}></span></button>:''}
                  </form>
                  <div className={`clear`}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`QuickSearchDomain__bottom clearfix`}>
          <div className={`bottom__container clearfix`}>
            <div className={`bottom__table clearfix`}>
              {renderFeaturedDomain()}
              <a key={"viewpricingmobile"} className={`table__column table__column--viewpricingmobile  clearfix table__column`}
                 href={domain_pricing?domain_pricing:"/domain-rego/domains-pricing/"}>View Full Pricing</a>
            </div>
            <div className={`bottom__more-info clearfix`}>
              <span className={`more-info__right clearfix`}>All prices are shown in Australian currency(AUD).</span>
              <div className={`clear`}></div>
              {viewport!=="xs"?<a href={
                domain_pricing?domain_pricing:"/domain-rego/domains-pricing/"}
                                  className={`more-info__left clearfix`}>View Full Pricing</a>:''}
            </div>
          </div>
        </div>
      </div>
      ,container
    )
  }
}
QuickSearchDomain.propTypes = {
  ajax_url: PropTypes.string,
  pageID: PropTypes.string,
  theme_url: PropTypes.string,
  ordering_site: PropTypes.string,
  domain_pricing: PropTypes.string,
  container: PropTypes.any,
  history: PropTypes.any
}

const QuickSearchDomainRouter = withRouter(QuickSearchDomain)

export const RenderQuickSearchDomain = (props) =>{
  const domlist = Array.from(document.querySelectorAll(`.${QUICK_BULK_SEARCH_CLASSNAME}`))
  const {router} = props
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const button_label = el.getAttribute('data-button-label')
      const placeholder = el.getAttribute('data-placeholder')
      const transfer = el.getAttribute('data-transfer')
      const ajax_url =  el.getAttribute('data-ajax-url')
      const pageID =  el.getAttribute('data-page-id')
      const theme_url =  el.getAttribute('data-theme-url')
      const ordering_site =  el.getAttribute('data-ordering-site')
      const domain_pricing =  el.getAttribute('data-domain-pricing')
      return (<QuickSearchDomainRouter
        button_label = {button_label}
        key = {index}
        container = {el}
        placeholder = {placeholder}
        router = {router}
        transfer = {transfer}
        pageID = {pageID}
        ajax_url = {ajax_url}
        theme_url = {theme_url}
        ordering_site = {ordering_site}
        domain_pricing = {domain_pricing }
      />)
    })
  }
  return (<></>)
}

RenderQuickSearchDomain.propTypes = {
  container: PropTypes.any,
  router: PropTypes.any
}